export default [
  {
    path: "/version",
    component: () => import("@/views/reports/Version.vue"),
    meta: {
      authorization: { policies: ["verensics-administrator"] },
    },
  },
];
